import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private readonly baseUrl = environment.apiUrl;

  constructor(private http: HttpClient, private apiService: ApiService) {}

  async getUserEvents(cardId: string): Promise<any> {
    const headers = await this.apiService['getHeaders']();
    return this.http.get(`${this.baseUrl}/cards/analytics/${cardId}`, { headers }).toPromise();
  }
  
  async getCardsEventSummary(): Promise<any> {
    const headers = await this.apiService['getHeaders']();
    return this.http.get(`${this.baseUrl}/analytics/data/summary`, { headers }).toPromise();
  }
}